import {
	API_START,
	API_END,
	FETCH_ADD_GOOD_DEAL_CATEGORY,
	SET_ADD_GOOD_DEAL_CATEGORY_RESULT,
	FETCH_UPDATE_GOOD_DEAL_CATEGORY,
	SET_UPDATE_GOOD_DEAL_CATEGORY_RESULT,
	FETCH_REORDER_GOOD_DEALS_CATEGORIES,
	SET_REORDER_GOOD_DEALS_CATEGORIES_RESULT,
	SET_GOOD_DEAL_CATEGORY_FAILURE,
	SET_GOOD_DEALS_CATEGORIES_PICTOS,
	RESET_DATA
} from "../actions/types";

const initialState = {
	isFetching: false,
	snackInfoMsg: null,
	snackErrorMsg: null,
	// Pictograms by name ({ [name]: uri })
	pictos: {}
};

const SAVING_LABELS = [
	FETCH_ADD_GOOD_DEAL_CATEGORY,
	FETCH_UPDATE_GOOD_DEAL_CATEGORY,
	FETCH_REORDER_GOOD_DEALS_CATEGORIES
];

const getErrorMessage = error => {
	switch (error?.response?.status) {
		case 409:
			return "Une catégorie porte déjà ce nom.";
		case 422:
			return "Le nom de la catégorie est obligatoire.";
		default:
			return "Une erreur inattendue est survenue.";
	}
};

export default function gooddealCategoryReducer(
	state = initialState,
	action = {}
) {
	switch (action.type) {
		case API_START:
			if (SAVING_LABELS.includes(action.payload)) {
				return {
					...state,
					isFetching: true,
					snackInfoMsg: null,
					snackErrorMsg: null
				};
			}
			return state;

		case API_END:
			if (SAVING_LABELS.includes(action.payload)) {
				return { ...state, isFetching: false };
			}
			return state;

		case SET_ADD_GOOD_DEAL_CATEGORY_RESULT:
			return { ...state, snackInfoMsg: "La catégorie a été ajoutée." };

		case SET_UPDATE_GOOD_DEAL_CATEGORY_RESULT:
			return { ...state, snackInfoMsg: "La catégorie a été modifiée." };

		case SET_REORDER_GOOD_DEALS_CATEGORIES_RESULT:
			return { ...state, snackInfoMsg: "Les catégories ont été réorganisées." };

		case SET_GOOD_DEAL_CATEGORY_FAILURE:
			return { ...state, snackErrorMsg: getErrorMessage(action.payload) };

		case SET_GOOD_DEALS_CATEGORIES_PICTOS:
			return { ...state, pictos: action.payload || {} };

		case RESET_DATA:
			return initialState;

		default:
			return state;
	}
}
